import { getRgObjectsOfType as o, RG_TYPE as i } from "@project-rouge/rg-core";
import { getGlazedFacadeArea as c } from "./index27.js";
import { getGrossFacadeArea as d } from "./index28.js";
const f = (r) => {
  let e = 0;
  const a = o(r, i.Building);
  for (const t of a)
    e += d(t) - c(t);
  return e;
};
export {
  f as getNetFacadeArea
};
//# sourceMappingURL=index36.js.map
